export default __webpack_public_path__ + "static/media/showreel-mobile.54647def.mp4";